import { Button, Input } from "@delibrandev/utils";

export const OptionsList = ({ styles, groupActive, optionDrafts, setOptionDrafts, onSaveOptionName }) => {
  if (!groupActive) return null;

  if (!groupActive.options?.length) {
    return <div className={styles.empty}>Este grupo no tiene opciones.</div>;
  }

  return (
    <div className={styles.optionsList}>
      {groupActive.options.map((opt) => (
        <div key={opt.optionId} className={styles.optionRow}>
          <div className={styles.optionInput}>
            <Input
              id={opt.optionId}
              type="text"
              placeholder=""
              classname="w-100"
              icon={null}
              iconType={null}
              iconPositionRight
              label=""
              description=""
              defaultValue={optionDrafts[opt.optionId] ?? ""}
              onChange={(value) => setOptionDrafts((prev) => ({ ...prev, [opt.optionId]: value }))}
            />
          </div>

          <div className={styles.optionActions}>
            <Button text="Guardar" icon={null} customClass="customButtonColor2" action={() => onSaveOptionName(opt.optionId)} />
          </div>
        </div>
      ))}
    </div>
  );
};
